export type ExampleQuestion = { title: string; description: string };

export function buildExampleQuestions(propertyName: string | null): ExampleQuestion[] {
  const base: ExampleQuestion[] = [
    {
      title: 'Check compliance',
      description: 'What certificates are expiring in the next 90 days?',
    },
    {
      title: 'Check maintenance compliance',
      description: 'Which elevators missed maintenance last month?',
    },
  ];
  if (!propertyName) return base;
  return [
    ...base,
    {
      title: 'Property status',
      description: `How is ${propertyName} doing this quarter?`,
    },
    {
      title: 'Analyze callback trends',
      description: `Show me callback rate trends for ${propertyName} over the past 12 months.`,
    },
  ];
}

export function greeting(date: Date = new Date()): 'Morning' | 'Afternoon' | 'Evening' {
  const h = date.getHours();
  if (h >= 5 && h < 12) return 'Morning';
  if (h >= 12 && h < 18) return 'Afternoon';
  return 'Evening';
}
